export const DOCUMENT_TYPE = {
  tenderPackage: 10,
  bid: 20,
  contract: 30,
  supplement: 50,
  tenderFeedback: 60,
  internalKnowledgeBase: 70,
  subcontractor: 90,
  workPackage: 100,
  project: 110,
} as const;

export type DocumentTypeName = keyof typeof DOCUMENT_TYPE;

export type DocumentType = (typeof DOCUMENT_TYPE)[DocumentTypeName];

export enum DocumentFailureReason {
  COPY_PROTECTED_PDF = 'COPY_PROTECTED_PDF',
  PASSWORD_PROTECTED_PDF = 'PASSWORD_PROTECTED_PDF',
  FILE_UNAVAILABLE = 'FILE_UNAVAILABLE',
  PARSER_FAILED = 'PARSER_FAILED',
  NO_READABLE_CONTENT = 'NO_READABLE_CONTENT',
  STANDARD_EXTRACTION_FAILED = 'STANDARD_EXTRACTION_FAILED',
  UPLOAD_CANCELLED = 'UPLOAD_CANCELLED',
  PROCESSING_INTERRUPTED = 'PROCESSING_INTERRUPTED',
  UNKNOWN = 'UNKNOWN',
}

export type FileExtensions =
  | 'UNKNOWN'
  | 'PDF'
  | 'DOCX'
  | 'DOTX'
  | 'EPUB'
  | 'XLSX'
  | 'XLSM'
  | 'CSV'
  | 'IFC'
  | 'RVT';

export const DOCUMENT_EXTENSION_GROUPS = {
  documents: ['.pdf', '.docx', '.doc', '.rtf', '.txt', '.md', '.pptx', '.ppt', '.epub'],
  spreadsheets: ['.xlsx', '.xlsm', '.xls', '.xlsb', '.csv', '.tsv'],
  schedules: ['.mpp', '.xer', '.xml', '.pmxml', '.pp', '.gan'],
  billsOfQuantities: ['.x81', '.x82', '.x83', '.x84', '.x85', '.x86', '.bc3'],
  models: ['.ifc', '.rvt'],
  drawings: ['.dwg', '.dxf'],
  emails: ['.msg', '.eml'],
  images: ['.png', '.jpg', '.jpeg', '.tif', '.tiff', '.bmp', '.gif', '.heic', '.webp'],
};

export const STALL_POLL_INTERVAL_MS = 60 * 1000;
